import React, { Component } from "react";
import {
  Button,
  Row,
  TabContent,
  TabPane,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Container,
} from "reactstrap";
import { useTranslation, withTranslation } from "react-i18next";
import metrics from "../../../common/metrics";
import * as BB from "../../../components/BBComponent";
import { Popup } from "devextreme-react/popup";
import { withRouter } from "react-router-dom";
import notify from "devextreme/ui/notify";
import axios, { post } from "axios";
import { connect } from "react-redux";
import { AppSwitch } from "@coreui/react";
import USER from "../../../assets/user.png";
import { callAPI, callApiGet, callApiPost } from "../../../components/Axios";
import jwt_decode from "jwt-decode";
import { List } from "devextreme-react";
import { t } from "i18next";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (event) => {
    if (event.target.value === "en") {
      document.cookie = "Culture=en-EN";
    } else {
      document.cookie = "Culture=tr-TR";

    }
    let token = localStorage.getItem("token");

    let user = jwt_decode(token);
    let url = "/api/Login/checkUserLoginByID?userID=" + user.ID;
    callAPI(
      callApiGet,
      url,
      {},
      (res) => {
        if (res?.data) {
          localStorage.setItem("token", res.data.Token);
          window.location.reload();
        }
      },
      true
    );
    i18n.changeLanguage(event.target.value);
  };

  let checked = document.cookie == "Culture=en-EN" ? true : false;
  return (

    <div onChange={changeLanguage} style={{ marginLeft: 20 }}>
      <Row>
        <input
          type="radio"
          value="tr"
          name="language"
          defaultChecked={document.cookie.indexOf("tr-TR") > -1 || document.cookie.indexOf("Culture") < 0}
          style={{ marginTop: 10, marginRight: 10, marginBottom: -20 }}
        />
        <p>Türkçe</p>
      </Row>
      <Row>
        <input
          type="radio"
          value="en"
          name="language"
          defaultChecked={document.cookie.indexOf("en-EN") > -1}
          style={{ marginTop: 10, marginRight: 10, marginBottom: -20 }}
        />
        <p>English</p>
      </Row>
    </div>
  );
};

const WatcherListItem = ({ item, event }) => {
  return (<div className="list-group-item pl-3 pr-3">
    <div className="d-flex align-items-center mb-3">
      <div className="flex-fill pl-3 pr-3">
        <div className="font-weight-600 text-truncate width-100">
          {item.Name}
        </div>
      </div>
      <Button color="warning"
        style={{ marginRight: 8 }}
        onClick={() => {

          let cacheUsers = [];
          item.WatchersUsers.map((user => {
            cacheUsers.push(user.UserID);
          }));
          event.setState({
            selectedWatcherGroupUsers: [],
            watcherGroupName: item.Name,
            editWatcherList: true,
            selectedWatcherGroupID: item.ID
          });
          event.GetWatcherGroupUsers([item.ID], false);
        }}
      >{t("goruntule")}</Button>
      <Button color="danger"
        onClick={() => {
          event.DeleteWatcherGroupByID(item.ID);
        }}
      >{t("sil")}</Button>
    </div>
  </div>);
}

const WatcherListComponent = ({ items, event }) => {
  return (
    <div>
      {items.map((item) => (
        <WatcherListItem key={item.id} item={item} event={event} />
      ))}
    </div>
  );
};

class Profile extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      activeTab: new Array(2).fill("2"),
      passwordPopupVisible: false,
      changeMailSetting: false,
      selectedCommentFiles: [],
      emailList: [],
      tempArray: [],
      tempArray2: [],
      counter: 0,
      newPoolTaskMailSetting: false,
      taskCanceledMailSetting: false,
      taskStatusTakenMailSetting: false,
      taskManagerToRejectMailSetting: false,
      taskManagerApprovedMailSetting: false,
      taskManagerWillApproveMailSetting: false,
      DescriptionMailSetting: false,
      RemindingMailSetting: false,
      AutomaticStateSwitchingMailSetting: false,
      TaskAssignedMailSetting: false,
      AddedMovementToMissionMailSetting: false,
      emailListLenght: 0,
      departmentUser: [],
      userPools: [],
      user: {
        Name: "",
        SurName: "",
        UserName: "",
        Manager: {
          Name: "",
        },
        Photo: "",
      },
      text: "",
      addWatcherPopup: false,
      watcherGroupName: undefined,
      watcherGroupUsers: [],
      selectedWatcherGroupUsers: [],
      oldGroupUsers: [],
      editWatcherList: false,
      oldSelectedGroup: undefined,
      oldSelectedGroupUsersList: undefined,
      selectedWatcherGroups: [],
      selectedGroupUsersID: [],
      selectedWatcherGroupID: undefined
    };
    // {t("ayarlar")}
    this.toggle = this.toggle.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.getUserData();
    this.getEmailNames();
    this.getWatcherUserList();
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getWatcherUserList() {
    BB.FetchJSON("/api/User/GetUserList").then((data) => {
      this.setState({ watcherGroupUsers: data });
    });
  }


  saveWatcherGroup() {
    if (this.state.watcherGroupName === undefined || this.state.selectedWatcherGroupUsers.length == 0 || this.state.watcherGroupName.trim() === "") {
      notify(
        "Lütfen gerekli alanları doldurunuz.",
        "warning",
        5000
      );
    } else {
      let watcherGroup = {
        Name: this.state.watcherGroupName
      }

      let entity = {
        WatcherGroup: watcherGroup,
        WatcherGroupUsers: this.state.selectedGroupUsersID
      }
      const formData = new FormData();
      formData.append("jsonText", JSON.stringify(entity));
      post("api/User/AddWatcherGroup", formData).then((res) => {
        this.setState({
          watcherGroupName: undefined,
          selectedWatcherGroupUsers: [],
          addWatcherPopup: false,
          selectedWatcherGroups:[]
        });
        this.GetWatcherGroups();
        notify(
          "İzleyici Grubu Başarıyla Oluşturulmuştur.",
          "success",
          5000
        );
      }).catch((err) => {
        this.setState({
          watcherGroupName: undefined,
          selectedWatcherGroupUsers: [],
          addWatcherPopup: false
        });

        notify(
          "İzleyici Grubu Oluşturulurken Hata Oluştu.",
          "warning",
          5000
        )
      });
    }
  }

  UpdateWatcherGroup() {
    let data = {
      ID: this.state.selectedWatcherGroupID,
      Name: this.state.watcherGroupName,
      users: this.state.selectedWatcherUserList
    }
    let formData = new FormData();
    formData.append("id", this.state.selectedWatcherGroupID);
    formData.append("name", this.state.watcherGroupName);
    formData.append("users", JSON.stringify(this.state.selectedWatcherUserList));

    callAPI(
      callApiPost,
      "/api/User/UpdateWatcherGroup",
      formData,
      (res) => {
        
        if (res?.data) {
          notify(
            "İzleyici Grubu Başarıyla Güncellendi.",
            "success",
            5000
          );
         
          this.GetWatcherGroups();
        } else {
          notify(
            "İzleyici Grubu Güncelleştirilirken Hata Oluştu.",
            "warning",
            5000
          )
        }
      }
    );
    this.setState({
      selectedWatcherGroupID: undefined,
      watcherGroupName: undefined,
      selectedWatcherUserList: [],
      editWatcherList: false,
      selectedWatcherUserID: []
    });
    this.getWatcherUserList()
  }

  GetWatcherGroupUsers(groupID, isWithGroupName) {
    callAPI(
      callApiGet,
      `api/User/GetGroupUsersByGroupId`,
      { watchersGroupID: JSON.stringify(groupID) },
      async (res) => {
        let splittedName = []
        if (!isWithGroupName) {
          res?.data.map(x => {
            splittedName.push({
              ID: x.ID,
              Name: x.Name.split(")")[1]
            });
          });
          this.setState({ selectedWatcherUserList: splittedName });
        } else {
          this.setState({ selectedWatcherUserList: res?.data });

        }
        // if (res?.data) {
        //   this.setState({
        //     oldGroupUsers: res?.data
        //   });
        // }
      },
      true
    );
  }


  GetUsersForGroup(groupID) {
    callAPI(
      callApiGet,
      `api/User/GetUserInfo`,
      { getUsersID: JSON.stringify(groupID) },
      async (res) => {
        this.setState({ selectedWatcherUserList: res?.data });
        // if (res?.data) {
        //   this.setState({
        //     oldGroupUsers: res?.data
        //   });
        // }
      },
      true
    );
  }

  getUserData() {
    BB.FetchJSON("api/User/GetUserDetail").then((data) => {
      this.setState({ user: data });
    });

    BB.FetchJSON("api/User/GetUserDepartment").then((data) => {
      this.setState({ departmentUser: data });
    });

    BB.FetchJSON("api/User/GetUserPool").then((data) => {
      this.setState({ userPools: data });
    });
  }

  toggle(tabPane, tab) {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  }

  tabPane() {
    const { t } = this.props;

    return (
      <>
        <TabPane tabId="1">
          <div className="tab-pane fade show"></div>
        </TabPane>
        <TabPane tabId="2">
          <div className="tab-pane fade show">
            <strong>{t("profil")}</strong>
            <div style={{ maxWidth: 130 }}>
              <LanguageSelector />
            </div>
          </div>
        </TabPane>
        <TabPane tabId="3">
          <div className="tab-pane fade show">
            <div className="card mb-3">
              <div className="card-header font-weight-600 bg-transparent">
                May 20
              </div>
              <div className="card-body">
                <div className="widget-img-list" />
              </div>
            </div>
            <div className="text-center p-3">
              <a href="#" className="text-dark text-decoration-none">
                Show more <b className="caret" />
              </a>
            </div>
          </div>
        </TabPane>
      </>
    );
  }

  handleChange = (id, value) => {
    if (id === "selectedCommentFiles") {
      this.setState({ selectedCommentFiles: value.target.files });
    } else {
      this.setState({ [id]: value });
    }
  };

  getEmailNames() {
    let url = "/api/Common/GetEmailsName2";

    callAPI(
      callApiGet,
      url,
      {},
      (res) => {
        if (res?.data) {
          var List2 = [];
          var List1 = res?.data;
          this.setState({
            emailList: res?.data,
            emailListLenght: res?.data.length - 1,
          });

          // var emailListLength = this.state.emailList.length;
          // var midIndex = emailListLength / 2;
          // var HalfIndex = Math.ceil(midIndex);
          // for (let i = 0; i < HalfIndex; i++) {
          //   List1.splice(i, 1);
          //   List2.push(res?.data[i]);
          // }
        }
      },
      true
    );
  }



  handleChangeInput(e) {
    const { name, value } = e.target;

    this.setState({
      user: Object.assign({}, this.state.user, { [name]: value }),
    });
  }

  // Şifre politikası kontrolü
  validatePasswordPolicy(password) {
    const errors = [];
    
    if (password.length < 8) {
      errors.push("En az 8 karakter");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("En az bir büyük harf");
    }
    if (!/[a-z]/.test(password)) {
      errors.push("En az bir küçük harf");
    }
    if (!/[0-9]/.test(password)) {
      errors.push("En az bir rakam");
    }
    if (!/[^A-Za-z0-9]/.test(password)) {
      errors.push("En az bir özel karakter");
    }
    
    return errors;
  }

  changePassword() {
    const { password, newPassword, newPasswordRepeat } = this.state;

    if (
      password === "" ||
      password === undefined ||
      newPassword === "" ||
      newPassword === undefined ||
      newPasswordRepeat === undefined ||
      newPasswordRepeat === ""
    ) {
      notify("Lütfen zorunlu alanları doldurunuz.", "warning", 5000);
    } else {
      // Şifre politikası kontrolü
      const policyErrors = this.validatePasswordPolicy(newPassword);
      if (policyErrors.length > 0) {
        notify(
          "Şifre gereksinimleri: " + policyErrors.join(", "),
          "warning",
          7000
        );
        return;
      }

      if (newPassword === newPasswordRepeat) {
        axios(`api/Login/ChangePassword`, {
          method: "POST",
          headers: { "content-type": "application/json" },
          data: { OldPassword: password, Password: newPassword },
        })
          .then((response) => {
            if (response.data.MessageStatus === true) {
              this.setState({
                passwordPopupVisible: false,
                password: "",
                newPassword: "",
                newPasswordRepeat: "",
              });
              notify(
                response.data.Message || "Şifreniz başarılı bir şekilde değiştirilmiştir.",
                "success",
                5000
              );
            } else {
              // Server'dan gelen detaylı hata mesajını göster
              notify(
                response.data.Message || "Şifre değiştirme işleminde hata.",
                "error",
                7000
              );
            }
          })
          .catch((error) => {
            notify(
              "Şifre değiştirme işleminde hata. " + error,
              "warning",
              5000
            );
          });
      } else {
        notify("Şifreler uyuşmamaktadır.", "warning", 10000);
      }
    }
  }

  changeSwitch(e) {
    let url = "/api/Common/ChangeMailPermission?ID=" + e;

    callAPI(
      callApiPost,
      url,
      {},
      (res) => {
        if (res?.data) {
          notify("Başarılı", "success", 2000);
          this.getEmailNames();
        }
      },
      true
    );
  }

  profileBody() {
    if (this.state.activeTab[0] === "2") {
      return this.profileSettings();
    } else if (this.state.activeTab[0] === "3") {
      return this.watcherListSettings();
    }
  }

  watcherListSettings() {
    const { t } = this.props;

    return (
      // Herhangibirveriyok
      <div className="profile-content">
        <div className="d-flex align-items-center justify-content-between" style={{ justifyContent: "flex-end !important" }}>
          <Button style={{ margin: 8, marginRight: 0 }}
            color="success"
            onClick={() => {
              this.setState({
                selectedWatcherGroupUsers: [],
                watcherGroupName: undefined,
                addWatcherPopup: true
              });
            }}
          >{t("olustur")}</Button>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="list-group list-group-flush">
              <div className="list-group-item font-weight-600 pl-3 pr-3 d-flex">
                <span className="flex-fill">{t("olusturdugumizlemegrupları")}</span>
              </div>
              <WatcherListComponent items={this.state.oldGroupUsers} event={this} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  getSelectedWatcherGroupDeails(groupId) {
    return (
      <div></div>
    );
  }

  GetWatcherGroups() {
    callAPI(
      callApiGet,
      `api/User/GetWatcherGroupsByUserId`,
      {},
      async (res) => {

        if (res?.data) {
          this.setState({
            oldGroupUsers: res?.data
          });
        }
      },
      true
    );
  }

  DeleteWatcherGroupByID(groupID) {
    callAPI(
      callApiGet,
      `api/User/DeleteWatcherGroup`,
      { groupID: groupID },
      async (res) => {

        if (res?.data) {
          this.GetWatcherGroups();
        }
      },
      true
    );
  }

  profileSettings() {
    const { t } = this.props;

    return (<div className="profile-content">
      <div className="row">
        <div className="col-xl-12">
          {/* Dil - Language - seçim yerini açıp kapatmak için */}
          <div className="tab-content p-0">
            <TabContent activeTab={this.state.activeTab[0]}>
              {this.tabPane()}
            </TabContent>
          </div>

        </div>
        <div className="col-xl-12">
          <div className="desktop-sticky-top d-lg-block">
            <div className="card mb-3">
              <div className="list-group list-group-flush">
                <div className="list-group-item font-weight-600 pl-3 pr-3 d-flex">
                  <span className="flex-fill">{t("ekibindekiKisiler")}</span>
                </div>
                <div className="list-group-item pl-3 pr-3">
                  {this.state.departmentUser.map((item, i) => {
                    return (
                      <div
                        className="d-flex align-items-center mb-3"
                        key={i}
                      >
                        <img
                          src={
                            item.Base64Photo
                              ? "data:image/png;base64, " +
                              item.Base64Photo
                              : "data:image/png;base64,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"
                          }
                          width="30px"
                          className="rounded-circle"
                        />
                        <div className="flex-fill pl-3 pr-3">
                          <div className="font-weight-600 text-truncate width-100">
                            {item.Name}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="desktop-sticky-top d-lg-block">
            <div className="card mb-3">
              <div className="list-group list-group-flush">
                <div className="list-group-item font-weight-600 pl-3 pr-3 d-flex">
                  <span className="flex-fill">
                    {t("yetkiliOldugumHavuzlar")}
                  </span>
                </div>
                <div className="list-group-item pl-3 pr-3">
                  {this.state.userPools.map((item, i) => {
                    return (
                      <div
                        className="d-flex align-items-center mb-3"
                        key={i}
                      >
                        <div className="flex-fill pl-3 pr-3">
                          <div className="font-weight-600 text-truncate width-100">
                            {item}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="desktop-sticky-top d-lg-block">
            <div className="card mb-3">
              <div className="list-group list-group-flush">
                <div className="list-group-item font-weight-600 pl-3 pr-3 d-flex">
                  <span className="flex-fill">{t("yonetici")}</span>
                </div>
                <div className="list-group-item pl-3 pr-3">
                  <div className="d-flex align-items-center mb-3">
                    <div className="flex-fill pl-3 pr-3">
                      {this.state.user.Manager && (
                        <div className="font-weight-600 text-truncate width-100">
                          {this.state.user.Manager.Name +
                            " " +
                            this.state.user.Manager.SurName}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);
  }

  saveProfile() {
    const url = `api/User/SetUserDetail`;

    const formData = new FormData();

    formData.append("jsonText", JSON.stringify(this.state.user));

    for (let i = 0; i < this.state.selectedCommentFiles.length; i++) {
      formData.append("file", this.state.selectedCommentFiles[i]);
    }

    const config = { headers: { "content-type": "multipart/form-data" } };

    post(url, formData, config).then((res) => {
      notify("Başarılı", "success", 2000);
      this.getUserData();
    });
  }

  render() {
    const { t } = this.props;
    let src = this.state.user.Photo
      ? "data:image/png;base64," + this.state.user.Photo
      : USER;

    return (
      <div className="profile">
        <div className="profile-header">
          <div className="profile-header-cover" />
          <div className="profile-header-content">
            <div className="profile-header-img">
              <div className="image-upload">
                <label htmlFor="selectedCommentFiles">
                  <img
                    src={this.state.user.Photo != "" ? src : USER}
                    className="upload-image"
                  />
                </label>
                <div className={"d-none"}>
                  {BB.FileWithLabel("selectedCommentFiles", "", this)}
                </div>
              </div>
            </div>

            <ul className="profile-header-tab nav nav-tabs nav-tabs-v2">
              <li
                className="nav-item"
                onClick={() => {
                  this.toggle(0, "2");
                }}
              >
                <div
                  className={`nav-link ${this.state.activeTab[0] === "2" && "active"
                    }`}
                >
                  <div className="nav-field">{t("ayarlar")}</div>
                  {/*<div className="nav-value">382</div> */}
                </div>
              </li>
              <li
                className="nav-item"
                onClick={() => {
                  this.setState({ passwordPopupVisible: true });
                }}
              >
                <div className={`nav-link`}>
                  <div className="nav-field">{t("sifreDegistir")}</div>
                  {/*<div className="nav-value">382</div> */}
                </div>
              </li>
              <li
                className="nav-item"
                onClick={() => {
                  this.setState({ changeMailSetting: true });
                }}
              >
                <div className={`nav-link`}>
                  <div className="nav-field">{t("mailBildirimYonetimi")}</div>
                </div>
              </li>
              <li
                className="nav-item"
                onClick={() => {
                  // this.setState({ addWatcherPopup: true });
                  this.toggle(0, "3");
                  this.GetWatcherGroups();

                }}
              >
                <div className={`nav-link ${this.state.activeTab[0] === "3" ? "active" : ""
                  }`}>
                  <div className="nav-field">{t("izleyiciGrubuOlustur")}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="profile-container">
          <div className="profile-sidebar">
            <div className="desktop-sticky-top">
              <h4>
                {this.state.user.Name} {this.state.user.SurName}
              </h4>
              <div className="font-weight-600 mb-3 text-muted mt-n2">
                @{this.state.user.UserName}
              </div>
              <div className="mb-1 d-flex align-items-center profile-edit-div">
                <i className="fa fa-building-o fa-fw text-muted" />
                {t("departmanIsmiveGorevi")}
              </div>
              <div className="mb-1 d-flex align-items-center profile-edit-div">
                <i className="fa fa-map-marker fa-fw text-muted" />
                <input
                  id="Address"
                  name="Address"
                  className="input-profile"
                  type="text"
                  value={this.state.user.Address || ""}
                  onChange={this.handleChangeInput}
                  autoComplete="off"
                />
                {/*<i class="fa fa-pencil icon"></i>*/}
              </div>
              <div className="mb-3  d-flex  align-items-center profile-edit-div">
                <i className="fa fa-link fa-fw text-muted" />
                <input
                  id="Email"
                  name="Email"
                  className="input-profile"
                  type="text"
                  value={this.state.user.Email || ""}
                  onChange={this.handleChangeInput}
                  autoComplete="off"
                />
              </div>
              <div className="mb-3  d-flex align-items-center profile-edit-div">
                <i className="fa fa-mobile fa-fw text-muted" />
                <input
                  id="MobilPhone"
                  name="MobilPhone"
                  className="input-profile"
                  type="number"
                  value={this.state.user.MobilPhone || ""}
                  onChange={this.handleChangeInput}
                  autoComplete="off"
                />
              </div>
              <div className="mb-3  d-flex align-items-center profile-edit-div">
                <i className="fa fa-phone fa-fw text-muted" />
                <input
                  size={4}
                  maxLength={4}
                  id="InternalNumber"
                  name="InternalNumber"
                  className="input-profile"
                  type="text"
                  value={this.state.user.InternalNumber || ""}
                  onChange={this.handleChangeInput}
                />
              </div>
              {/*onClick={() => this.sendFile()}*/}
              <Button color="success" onClick={() => this.saveProfile()} block>
                {t("profiliKaydet")}
              </Button>
              <hr className="mt-4 mb-4" />
            </div>
          </div>
          {this.profileBody()}
        </div>

        <Modal centered={true} isOpen={this.state.addWatcherPopup} size="md">
          <ModalHeader>{t("izleyiciGrubuOlustur")}</ModalHeader>
          <ModalBody>
            <Container>
              <Row>
                <Col lg={12}>
                  {BB.InputWithLabel("watcherGroupName", t("izleyiciGrupAdi"), "text", this, undefined)}
                </Col>
              </Row>
              <Row>
                <Col lg={8}>
                  {BB.DxMultipleDropdown("selectedWatcherGroupUsers", t("kullaniciEkleme"), this, this.state.watcherGroupUsers)}
                </Col>
                <Col lg={4}>
                  <Button
                    color={'light'}
                    block
                    style={{ marginTop: 27, float: 'right' }}
                    onClick={() => {
                      let selectedGroup = [];
                      let AllGroup = this.state.watcherGroupUsers;
                      let addingList = [];
                      let addingUsersID = [];

                      this.state.selectedWatcherGroupUsers.map((item, i) => {
                        selectedGroup.push(AllGroup.filter(x => x.ID == item)[0])
                      });

                      selectedGroup.map(sUser => {
                        let hasList = false;

                        this.state.selectedWatcherGroups.map(item => {
                          if (item.ID === sUser.ID) {
                            hasList = true;
                          }
                        })

                        if (hasList === false) {
                          addingList.push(sUser);
                          addingUsersID.push(sUser.ID);
                        }
                      })

                      this.setState({ selectedWatcherGroups: this.state.selectedWatcherGroups.concat(addingList) })
                      this.setState({ selectedGroupUsersID: this.state.selectedGroupUsersID.concat(addingUsersID) });
                    }}
                  >
                    {t("listeyeEkle")}
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <List
                    keyExpr={"ID"}
                    displayExpr={"Name"}
                    dataSource={this.state.selectedWatcherGroups}
                    height={110}
                    allowItemDeleting={true}
                    itemDeleteMode={"static"}
                    showSelectionControls={true}
                  />
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>

            <Button
              color={"info"}
              onClick={() =>
                this.setState({
                  watcherGroupName: undefined,
                  selectedWatcherGroupUsers: [],
                  addWatcherPopup: false,
                  selectedWatcherGroups:[]
                })
              }
            >
              {t("kapat")}
            </Button>
            <Button
              color={"success"}
              onClick={() => {
                this.saveWatcherGroup()
              }}
            >
              {t("olustur")}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal centered={true} isOpen={this.state.editWatcherList} size="md">
          <ModalHeader>İzleyici Grubu</ModalHeader>
          <ModalBody>
            <Row>
              <Col lg={12}>
                {BB.InputWithLabel("watcherGroupName", t("izleyiciGrupAdi"), "text", this, this.state.watcherGroupName)}
              </Col>
            </Row>
            <Row>
              <Col lg={8}>
                {BB.DxMultipleDropdown('selectedWatcherUserID', t("kullaniciSeciniz"), this, this.state.watcherGroupUsers)}
              </Col>
              <Col lg={4}>
                <Button
                  color={'light'}
                  block
                  style={{ marginTop: 27, float: 'right' }}
                  onClick={() => {
                    let oldSelectedUsers = [];
                    this.state.selectedWatcherUserList.map(i => {
                      oldSelectedUsers.push(i.ID);
                    });
                    let selectedAll = oldSelectedUsers.concat(this.state.selectedWatcherUserID)
                    // this.setState({ selectedWatcherUserList: this.state.selectedWatcherUserList.concat(addingList), })
                    this.GetUsersForGroup(selectedAll);
                  }}
                >
                  {t("listeyeEkle")}
                </Button>
              </Col>
            </Row>

            <Col>
              <List
                keyExpr={"ID"}
                displayExpr={"Name"}
                dataSource={this.state.selectedWatcherUserList}
                height={330}
                allowItemDeleting={true}
                itemDeleteMode={"static"}
                showSelectionControls={true}
              />
            </Col>
          </ModalBody>
          <ModalFooter>
            <Button
              color={"info"}
              onClick={() =>{

                this.setState({
                  editWatcherList: false,
                  selectedWatcherUserList: [],
                  watcherGroupName: undefined,
                  selectedWatcherUserID: [],
                  watcherGroupUsers: []
                })
                this.getWatcherUserList()
              }
              }
            >
              {t("kapat")}
            </Button>
            <Button
              color={"success"}
              onClick={() => {
                this.UpdateWatcherGroup()
              }}
            >
              {t("guncelle")}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal centered={true} isOpen={this.state.changeMailSetting} size="lg" scrollable>
          <ModalHeader>{t("mailGonderimAyari")}</ModalHeader>

          <ModalBody>
            <Container>
              {this.state.emailList.map((item, index) => {
                const index2 = parseInt(this.state.emailList.length) / 2;
                const HalfIndex = Math.floor(index2);
                const s = this.state.emailListLenght - index;
                if (s === index) {
                } else if (HalfIndex === index) {
                } else if (HalfIndex < index) {
                } else {
                  return (
                    <Row key={index}>
                      <Col xs="4">
                        <div className="aside-options">
                          <div className="clearfix mt-4">
                            <small>
                              <b>{this.state.emailList[index].Name}</b>
                            </small>
                          </div>
                          <div>
                            <small className="text-muted">
                              {this.state.emailList[index].Description}
                            </small>
                          </div>
                        </div>
                      </Col>
                      <Col xs="2">
                        <div className="clearfix mt-4">
                          <AppSwitch
                            onChange={() => {
                              this.changeSwitch(this.state.emailList[index].ID);
                            }}
                            //key={this.state.emailList[index].ID}
                            className={"float-right"}
                            variant={"pill"}
                            label
                            color={"success"}
                            checked={this.state.emailList[index].IsActive}
                            size={"sm"}
                          />
                        </div>
                      </Col>

                      <Col xs="4">
                        <div className="aside-options">
                          <div className="clearfix mt-4">
                            <small>
                              <b>{this.state.emailList[s].Name}</b>
                            </small>
                          </div>
                          <div>
                            <small className="text-muted">
                              {this.state.emailList[s].Description}
                            </small>
                          </div>
                        </div>
                      </Col>
                      <Col xs="2">
                        <div className="clearfix mt-4">
                          <AppSwitch
                            onChange={() => {
                              this.changeSwitch(this.state.emailList[s].ID);
                            }}
                            className={"float-right"}
                            variant={"pill"} fv
                            label
                            color={"success"}
                            checked={this.state.emailList[s].IsActive}
                            size={"sm"}
                          />
                        </div>
                      </Col>
                    </Row>
                  );
                }
              })}
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button
              color={"info"}
              onClick={() =>
                this.setState({
                  changeMailSetting: false,
                })
              }
            >
              {t("kapat")}
            </Button>
          </ModalFooter>
        </Modal>







        <Popup
          visible={this.state.passwordPopupVisible}
          dragEnabled={false}
          showTitle={true}
          showCloseButton={false}
          title={t("parolamiDegistir")}
          width={metrics.popupMinWidth}
          height={380}
        >
          {BB.InputWithLabel("password", t("mevcutParola"), "text", this)}
          {BB.InputWithLabel("newPassword", t("yeniParola"), "text", this)}
          {BB.InputWithLabel(
            "newPasswordRepeat",
            t("yeniParolaTekrar"),
            "text",
            this
          )}
          <Row style={{ float: "right", marginRight: 0, marginTop: 10 }}>
            <Button
              color={"info"}
              onClick={() =>
                this.setState({
                  passwordPopupVisible: false,
                  editID: "",
                  departmentName: "",
                  password: "",
                  newPassword: "",
                  newPasswordRepeat: "",
                })
              }
            >
              {t("kapat")}
            </Button>
            <Button
              onClick={() => this.changePassword()}
              color={"primary"}
              style={{ marginLeft: 20, marginRight: 0 }}
            >
              {t("kaydet")}
            </Button>
          </Row>
        </Popup>
      </div>
    );
  }
}


export default withRouter(withTranslation()(connect()(Profile)));
